var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSelectionGroup = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.625 0c1.252 0 2.286.982 2.37 2.213l.005.162v14.25a2.383 2.383 0 0 1-2.213 2.37l-.162.005H7.375a2.383 2.383 0 0 1-2.37-2.213L5 16.625V2.375C5 1.123 5.982.089 7.213.005L7.375 0h14.25Zm0 1H7.375c-.71 0-1.301.55-1.369 1.243L6 2.375v14.25c0 .71.55 1.301 1.243 1.369l.132.006h14.25c.71 0 1.301-.55 1.369-1.243l.006-.132V2.375c0-.71-.55-1.301-1.243-1.369L21.625 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 5v1h-.625c-.71 0-1.301.55-1.369 1.243L1 7.375v14.25c0 .71.55 1.301 1.243 1.369l.132.006h14.25c.71 0 1.301-.55 1.369-1.243l.006-.132V21h1v.625a2.383 2.383 0 0 1-2.213 2.37l-.162.005H2.375a2.383 2.383 0 0 1-2.37-2.213L0 21.625V7.375c0-1.252.982-2.286 2.213-2.37L2.375 5H3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.061 6.26-2.68 4.914-1.527-1.528a.5.5 0 0 0-.801.13l-2.5 5A.5.5 0 0 0 9 15.5h10.948a.5.5 0 0 0 .464-.687l-2.587-6.41-.863-2.093a.5.5 0 0 0-.9-.05Zm.375 1.399.463 1.122 2.308 5.719H9.809l1.828-3.656 1.51 1.51a.5.5 0 0 0 .792-.115l2.497-4.58ZM10.5 3.5c-1.276 0-2 .724-2 2s.724 2 2 2 2-.724 2-2-.724-2-2-2Zm0 1c.724 0 1 .276 1 1s-.276 1-1 1-1-.276-1-1 .276-1 1-1Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSelectionGroup);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/selection-group.4a3142e9cf49bf81aecb222d72d89756.svg";